<template>
  <div class="class-material">
    <el-form :inline="true" :model="form" ref="form" @submit.native.prevent>
      <el-form-item label="" prop="name">
        <el-input v-model="form.name" clearable @keyup.enter.native="queryData"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryData">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryData">刷新</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="openScratchEditor(null)">创建项目</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border style="width: 100%" empty-text="暂无数据">
      <el-table-column prop="id" label="ID" width="100" align="center"></el-table-column>
      <el-table-column prop="works_name" label="项目名称"></el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button size="small" @click="openScratchEditor(scope.row.id)">查看</el-button>
          <el-button size="small" type="danger" @click="removeRecord(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :page-sizes="[page.pageSize]" layout="total, prev, pager, next, jumper"
                   :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage"
                   @current-change="changeCurrentPage"></el-pagination>
  </div>
</template>

<script>
import { getScratchUserRecordsList, postDeleteScratchUserRecords } from '@/api/scratcheditor'
import store from "../../store";
import {alertFun} from "../../components/alert";
export default {
  name: "scratchEditorList",
  data() {
    return {
      form: {
        name: ""
      },
      list: [], // 资料列表
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dialogVisible: false,
      libraryInfo: null, // 资料详情
    }
  },
  created() {},
  mounted() {
    this.getScratchList();
  },
  methods: {
    getScratchList() { // 获取资料
      getScratchUserRecordsList({
        title: this.form.name,
        pageSize: this.page.pageSize,
        page: this.page.currentPage
      }).then(res => {
        this.list = res.data.data;
        this.page.total = res.data.total;
      })
    },
    queryData() { // 点击查询
      this.changeCurrentPage(1);
    },
    changeCurrentPage(val) {
      this.page.currentPage = val;
      this.getScratchList();
    },
    openScratchEditor(id) {
      const isDevelopment = process.env.NODE_ENV !== 'production'
      let url
      if(isDevelopment) {
        url = 'http://localhost:8601/'
      }else{
        url = 'https://student.kjt61.com/scratch-editor/'
      }
      if (this.$isElectron()) {
        const {shell} = require("electron");
        url = url + '?token=' + store.getters.token
        if(id) {
          url = url + '&scratchPId='+id
        }
        shell.openExternal(url)
      }else{
        if(id) {
          url = url + '?scratchPId='+id
        }
        window.open(url,'_blank')
      }
    },
    removeRecord(id) {
      const that = this
      alertFun({title: '提示',content:'确定删除该记录吗?'}).then(()=>{
        postDeleteScratchUserRecords({id: id}).then(res=>{
          if(res.status === 1) {
            that.getScratchList()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.class-material {

  padding: 1.2rem;

  .el-button {
    background-color: #22C1D3;
    color: #FFF;
    font-size: 0.72rem;
    border: none;
  }

  .el-button--danger {
    color: #FFF!important;
    background-color: #F56C6C!important;
    border-color: #F56C6C!important;
  }

  .teaching-plan {
    padding: 0 0.8rem;

    .teaching-plan-title {
      text-align: center;
      margin-bottom: 1.2rem;
    }
  }

  // 表单样式 start
  .el-form {
    ::v-deep .el-input {
      .el-input__inner {
        background-color: #1F3A4C;
        border-color: #1FB1C3;
        color: #FFF;
        font-size: 0.72rem;
        height: 1.76rem;
        line-height: 1.76rem;
        width: 12rem;
      }
    }
  }
  .el-table, .el-table__expanded-cell{
    background: none;
  }
  // 表单样式 end
}
</style>
